import { ADDED_DATE_LABEL } from "../../../utils/constants";

// Column model for the Users List table header (UsersTableHeading.jsx).
// `sm` MUST equal the Bootstrap <Col sm={n}> the matching row cell uses in OfficeMate.jsx.

// Mirrors the desktop row in OfficeMate.jsx: Name 3, Email 2, Mobile 2,
// Added Date 2, Role 2, actions 1 — the six cells qa-fe's row renders.
export const USERS_COLUMNS = [
  { key: "name", label: "Name", sm: 3, sortable: true },
  { key: "email", label: "Email", sm: 2, sortable: true },
  { key: "mobileNumber", label: "Mobile Number", sm: 2, sortable: true },
  { key: "addedDate", label: ADDED_DATE_LABEL, sm: 2, sortable: true },
  { key: "role", label: "Role", sm: 2, sortable: true },
  { key: "actions", label: "", sm: 1, sortable: false },
];

// 6dp matches Bootstrap's own .col-sm-* values (4/12 -> 33.333333%), so the
// header cell and its row cell resolve to the same width.
export const columnWidth = (sm) => ((sm / 12) * 100).toFixed(6) + "%";
